<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 20 20"
    style="enable-background: new 0 0 20 20"
    xml:space="preserve"
  >
    <path
      d="M10,8.9c-0.6,0-1.1,0.5-1.1,1.1v3.4c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1V10
	C11.1,9.4,10.6,8.9,10,8.9z M10,2c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S14.4,2,10,2z M10,16.9c-3.8,0-6.9-3.1-6.9-6.9
	S6.2,3.1,10,3.1s6.9,3.1,6.9,6.9S13.8,16.9,10,16.9z M10,5.4c-0.6,0-1.1,0.5-1.1,1.1S9.4,7.7,10,7.7s1.1-0.5,1.1-1.1
	S10.6,5.4,10,5.4z"
    />
  </svg>
</template>
